<template>
	<div>
		<div :class="isPc == true ? 'twoImgInfo warp' : ''">
			<div v-if="isPc == true" class="Nav-left">
				<ul>
					<li
						class="bluefont"
						:style="tabar_list_cur == index ? 'background-color: #0060B1; color: #fff;' : ''"
						@click="tabarchange(index)"
						v-for="(item, index) in tabar_list"
						:key="index"
					>
						{{ item }}
					</li>
				</ul>
			</div>

			<div v-if="isPc == false" class="mob-tabar-edu">
				<ul class="warp-mob bluefont">
					<li
						:style="tabar_list_cur == index ? 'background:linear-gradient(to top, #005FB2, #2583D4);color: #fff;' : ''"
						@click="tabarchange(index)"
						v-for="(item, index) in tabar_list"
						:key="index"
					>
						{{ item }}
					</li>
				</ul>
			</div>

			<div :class="isPc == true ? 'twoImgInfo_list' : 'twoImgInfo_list-mob warp-mob'">
				<ul>
					<li @click="getpage(item.id)" v-for="(item, index) in data" :key="index">
						<img :src="item.coverimage" />
						<div class="twoImgInfo_list_title">
							<h1>{{ item.title }}</h1>
							<p :class="isPc == true ? 'deepbluefont' : 'greyfont'">{{ item.createtime }}</p>
						</div>
						<div class="twoImgInfo_list_cont greyfont">
							<p>{{ item.introduction }}</p>
						</div>
					</li>
				</ul>
			</div>

			<div v-if="isPc == true" class="twoImgInfo_pagecut">
				<el-pagination
					@current-change="handleCurrentChange"
					background
					:current-page="currentPage"
					layout="prev, pager, next"
					:total="data_length"
					:page-size="page_size"
				></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'WebLijinhospitalEducat',

	data() {
		return {
			isPc: true,
			pid: 0,
			title: '',
			tabar_list: [],
			tabar_list_cur: 0,
			data: null,
			currentPage: 1,
			data_length: 0,
			page_size: 4
		};
	},

	mounted() {
		if ('id' in this.$route.query) {
			this.pid = this.$route.query['id'];
			this.title = this.$route.query['name'];
		} else {
			console.log('error');
		}
		if (document.body.clientWidth <= 820) {
			this.isPc = false;
			console.log(this.isPc);
		} else {
			this.isPc = true;
			console.log(this.isPc);
		}
		this.getdata(0);
	},

	methods: {
		handleCurrentChange(pageNumber) {
			this.currentPage = pageNumber;
			this.getdata(this.tabar_list_cur);
		},
		tabarchange(index) {
			this.currentPage = 1;
			this.tabar_list_cur = index;
			this.getdata(this.tabar_list_cur);
		},
		// 内容页
		getpage(e) {
			this.$router.push({
				path: '/content',
				query: { title: this.tabar_list[this.tabar_list_cur], id: e }
			});
		},
		getdata(i) {
			let _t = this;
			this.$axios({
				url: 'http://www.ljxzxyy.cn/api/index/article',
				params: {
					pid: _t.pid
				}
			})
				.then((res) => {
					//请求成功
					console.log('article', res.data.data);
					let plist = res.data.data;
					let index_arr = [];
					for (var i1 = 0; i1 < plist.length; i1++) {
						_t.tabar_list[i1] = plist[i1]['nickname'];
						index_arr[i1] = plist[i1]['id'];
					}
					let category_id = index_arr[i];
					this.$axios({
						url: 'http://www.ljxzxyy.cn/api/index/article',
						params: {
							category_id: category_id,
							num: this.page_size,
							page: this.currentPage
						}
					})
						.then((res) => {
							//请求成功
							console.log('article', res.data);
							this.data = res.data.data.list;
							this.data_length = res.data.data.count;
						})
						.catch((error) => {
							//请求失败
							console.log('article', error);
						});
				})
				.catch((error) => {
					//请求失败
					console.log('article', error);
				});
		}
	}
};
</script>

<style lang="scss" scoped></style>
